export default __webpack_public_path__ + "big-img-desktop-a7f44106936e2b1346793a41a8ce64d5.png";